import React from "react";
import cx from "clsx";

import { useGlobalDataContext } from "./GlobalDataContext";

import "./index.scss";

import Header from "./app/containers/Header";

import Bets from "./app/containers/Bets";
import Basket from "./app/containers/Basket";
import Statistics from "./app/containers/Statistics";

import { ToastReact } from "./app/components/ToastMessage/index";

function GameScreen() {
  const { state, dispatch } = useGlobalDataContext();

  return (
    <>
      <div className="game-screen-model">
        <Header />
        <div className="body fli-1 fl-cntr pos-rel">
          {/*statistics and event history content*/}
          <div
            className={cx("fli-3 basket-aside fl-cntr-right-col", {
              [`preloader-layer`]: state.eventsOdds.length === 0
            })}
            style={{ marginRight: "0.4rem" }}
          >
            <Statistics />
          </div>

          {/*contend at the middle of the page*/}
          <div className=" fli-11 fl-cntr-col odds">
            <Bets />
          </div>

          {/*basket and ticket history content*/}
          <div
            className={cx("fli-4 basket-aside fl-cntr-right-col", {
              [`preloader-layer`]: state.eventsOdds.length === 0
            })}
          >
            <Basket />
          </div>
        </div>
      </div>
      {/*container for toast messages*/}
      <ToastReact />
    </>
  );
}

export default GameScreen;
